import {  VisibilityRounded, VisibilityOffRounded, Send, Close } from "@mui/icons-material";
import dayjs from '../../../utils/dayjs-setup';
import { Button, Chip, Collapse, GridLegacy as Grid, IconButton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tooltip } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel, SelectInputWithLabel } from "../../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../../store/AppStore";
import { AxiosInstance, DateFormatString, DialogType,  FormActions, FormatPrice,  usuarioEntity } from "../../../utils/constants";
import * as yup from "yup";
import { ModalComprarCotizaciones } from "../../../components/form/ModalForm";

import { FilterForm } from "../../../components/form/filter-form";
import { CustomDialog } from "../../../components/modals/custom-dialog";



const schemaFilter = yup.object({
  

}).required();


const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:"",
  proveedor:null,
  estado_cesta:"TODAS"
};


const origenesDelProducto = (prod)=>{
  if (prod.origenes?.length) {
    return prod.origenes;
  }
  return [{
    cesta_cod: prod.cesta_cod,
    cod_cotizacion: prod.cod_cotizacion,
    total_compra_um: prod.total_compra_um,
    total_comprado_kg: prod.total_comprado_kg,
    estado: prod.estado,
    cod_erp_unidad_compra: prod.cod_erp_unidad_compra,
    nombre_municipio: prod.nombre_municipio,
    cod_municipio: prod.cod_municipio,
    precio_cotizado: prod.precio_cotizado,
  }];
}

const etiquetaCiudad = (origen)=> origen.nombre_municipio || `Cot. ${origen.cod_cotizacion}`;

const CantidadesEnColumnas = ({
  origenes,
  onResetearCesta
})=>{
  const varias = origenes.length > 1;
  const totalUm = origenes.reduce((suma, origen)=> suma + Number(origen.total_compra_um || 0), 0);
  const totalKg = origenes.reduce((suma, origen)=> suma + Number(origen.total_comprado_kg || 0), 0);
  const unidad = origenes[0]?.cod_erp_unidad_compra || "";
  const columnas = varias ? [...origenes, { cesta_cod:"total", esTotal:true }] : origenes;

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          {columnas.map(columna => (
            <TableCell key={columna.cesta_cod} sx={{ minWidth: 150, verticalAlign: "middle" }}>
              {columna.esTotal ? "Total" : (
                <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={0.5}>
                  <span>{etiquetaCiudad(columna)}</span>
                  <Tooltip title="Resetear">
                    <span>
                      <IconButton
                        size="small"
                        aria-label={`Resetear ${etiquetaCiudad(columna)}`}
                        disabled={columna.estado !== "PRECONFIRMADO"}
                        onClick={()=>onResetearCesta([columna.cesta_cod])}
                        sx={{
                          backgroundColor: "error.main",
                          color: "#fff",
                          "&:hover": { backgroundColor: "error.dark" },
                          "&.Mui-disabled": {
                            backgroundColor: "error.main",
                            color: "#fff",
                            opacity: 0.45,
                          },
                        }}
                      >
                        <Close fontSize="small" sx={{ color: "#fff" }} />
                      </IconButton>
                    </span>
                  </Tooltip>
                </Stack>
              )}
            </TableCell>
          ))}
        </TableRow>
        <TableRow>
          {columnas.map(columna => (
            <TableCell key={`${columna.cesta_cod}-etiquetas`}>
              <Table size="small">
                <TableBody>
                  <TableRow>
                    <TableCell sx={{ border: "none", width: 110, py: 0.5 }}>Cantidad (UM)</TableCell>
                    <TableCell sx={{ border: "none", width: 110, py: 0.5 }}>Cantidad (KG)</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          {columnas.map(columna => (
            <TableCell key={`${columna.cesta_cod}-valor`}>
              <Table size="small">
                <TableBody>
                  <TableRow>
                    <TableCell sx={{ border: "none", width: 110, py: 0.5 }}>
                      {columna.esTotal
                        ? `${totalUm.toFixed(2)} ${unidad}`
                        : `${Number(columna.total_compra_um || 0).toFixed(2)} ${columna.cod_erp_unidad_compra || ""}`}
                    </TableCell>
                    <TableCell sx={{ border: "none", width: 110, py: 0.5 }}>
                      {columna.esTotal ? `${totalKg} KG` : `${columna.total_comprado_kg} KG`}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableCell>
          ))}
        </TableRow>
      </TableBody>
    </Table>
  );
}

const SubtableItemsCesta = ({
  items,
  onResetearCesta
})=>{

  const columnsTable = [
    {
      key:"cod_cotizacion",
      keyValue:"cod_cotizacion",
      label:"Cotizacion",
      headerRender:(props)=>props.label,
      bodyRender:({info})=>{
        const cotizaciones = [...new Set(origenesDelProducto(info).map(origen => origen.cod_cotizacion).filter(Boolean))];
        return cotizaciones.length ? cotizaciones.join(", ") : info.cod_cotizacion;
      },
    },
    {
      key:"nombre_producto",
      keyValue:"nombre_producto",
      label:"Producto",
      headerRender:(props)=>props.label,
      bodyRender:(props)=>props.value,
    },
    {
      key:"precio_cotizado",
      keyValue:"precio_cotizado",
      label:"Valor ofertado",
      headerRender:(props)=>props.label,
      bodyRender:({info})=>`$ ${FormatPrice(info.precio_cotizado)}`,
    },
    {
      key:"detalle",
      keyValue:"origenes",
      label:"Detalle",
      headerRender:(props)=>props.label,
      bodyRender:({info})=>(
        <CantidadesEnColumnas
          origenes={origenesDelProducto(info)}
          onResetearCesta={onResetearCesta}
        />
      ),
    },
  ]

  return (
    <Grid container >
      <Grid item xs={12} sm={12} md={12} >
        <Table>
            <TableHead>
              <TableRow>
                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }
              </TableRow>
          </TableHead>
          <TableBody>
                 {items.map( prod=> (
                    <TableRow key={prod.cesta_cod}  >
                    {
                      columnsTable.map(Col=>
                        <TableCell key={Col.key}  >
                          {<Col.bodyRender value={prod[Col.keyValue]} info={prod} />}
                       </TableCell>)
                    }
                  </TableRow>
                ))}
            </TableBody>
        </Table>
      </Grid>
    </Grid>
  )

}

export const MisCompras = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store:{profile}} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({...usuarioEntity});
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);
  const [productosOptions,setProductosOptions] = useState([]);
  const [proveedorOptions,setProveedorOptions] = useState([]);
  const [dialogInternalConfig,setDialogInternalConfig] = useState({});



    useEffect(()=>{

      
      loadInitData();

    },[]);
    

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);


    const loadInitData = async()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      await loadItems(false);
   
     

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }

    const loadItems =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("cotizaciones/obtener-cesta-list",{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value.data]);

     setTotalRows(value.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };

    const onHideDetailProduct = ()=>{
      setIsVisibleModalDetalle(false);
      setProductoSeleccionado({});
    }



    const onSearchProveedor = async (evt,value_search) => {

      if (value_search && value_search.length > 3) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-prov-by-filter", {
            search_query: value_search
          });
          setProveedorOptions(value);
          return value;
         }catch(e){
          return [];
         }
  
      }
  
  
  
    }



    const  setFilterAply = (filtros)=>{
      console.log({filtros});
      setFilterSearchPagination({
        ...filterSearchPagination,
        page_number:0,
        estado_cesta:filtros.estado_cesta,
        producto:filtros.producto?.value,
        proveedor:filtros.proveedor?.value
      });
     
    }

    const getCestaColor = status=>{
      if (status === 'BORRADOR'){
        return "default";
      }
      if (status === 'CONFIRMADO'){
        return "success";
      }
      if (status === 'PRECONFIRMADO'){
        return "secondary";
      }
      if (status === 'ERROR'){
        return "error";
      }
      return "default";
    }
  
    const columnsTable = [
      {
      
       key:"proveedor",
       keyValue:"proveedor",
       label:"Proveedor",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
      {
      
        key:"sucursal_proveedor",
        keyValue:"sucursal_proveedor",
        label:"Sucursal",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      {
        key:"nombre_bodega",
        keyValue:"nombre_bodega",
        label:"Bodega destino",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
        key:"recoge_en_finca",
        keyValue:"recoge_en_finca",
        label:"Recogida",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"fecha_creacion",
        keyValue:"fecha_creacion",
        label:"Fecha de creacion",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"fecha_entrega",
        keyValue:"fecha_entrega",
        label:"Fecha de entrega",
        headerRender:(props)=>props.label,
        bodyRender: (props) =>dayjs( props.value).format(DateFormatString) ,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      {
        
        key:"itemList",
        keyValue:"itemList",
        label:"Total items",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value.length,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
        
        key:"estado_cesta",
        keyValue:"estado_cesta",
        label:"Estado de la cesta",
        headerRender:(props)=>props.label,
        bodyRender:(props)=><Chip label={props.value} color={getCestaColor(props.value)}  />,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
        key:"acciones",
        keyValue:"itemList",
        label:"Comprar",
        headerRender:(props)=>props.label,
        bodyRender:({info})=><Stack
        direction="column"
        >
          <Button  disabled={info.estado_cesta !== 'PRECONFIRMADO'} onClick={e=>onAprobeConfirmacionOrdenCompra(info)} variant="contained" size="small" color="primary" ><Send /></Button>
        </Stack>,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
      },  
    ];
   
    const InputFilters = [

      {
        grid:{
          xs:4,
          md:4,
          sm:4
        },
        InputComponent:AutoCompleteInputWithLabel,
        keyValue:"proveedor",
        InputComponentProps:{
          label:"proveedor",
          fullWidth: true,
          isLoading: false,
          multiple:false,
          size:'small',
          onInputChange: onSearchProveedor,
          options: proveedorOptions || [],
          noOptionsText: "Lista vacia",
          getOptionLabel: (option) => option.label,
          isOptionEqualToValue: (option, value) => option.value === value.value,
          filterOptions:(x) => x,
        }
      },
      {
        grid:{
          xs:4,
          md:4,
          sm:4
        },
        InputComponent:SelectInputWithLabel,
        keyValue:"estado_cesta",
        items:["TODAS","BORRADOR","PRECONFIRMADO","CONFIRMADO","ERROR"].map(ele=>({value:ele,label:ele})),
        InputComponentProps:{
          label:"Estado",
          fullWidth: true,
          size:'small',

        }
      },
     
      ];

      const onOpenedDetal = (index)=>{
        let copyItems = [...dataSetProdctos];
        copyItems[index].openedDetail = copyItems[index].openedDetail?false:true;
        setDataSetProductos(copyItems);
      }

      const ResetearItemCesta = (cestaIds)=>{
        const ids = (Array.isArray(cestaIds) ? cestaIds : [cestaIds]).filter((id) => id !== null && id !== undefined && id !== "");

        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });

        AxiosInstance.post("cotizaciones/resetear-cesta-preaprobada",{
          cesta_id: ids[0],
          cesta_ids: ids
         })
         .then(({data})=>{
          

         }).catch(error=>{

          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });

         })
         .finally(()=>{
          loadItems();
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
         });


      }

      const confirmarOrdenCompra = (infoData)=>{

        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });

        AxiosInstance.post("cotizaciones/confirmar-cesta-preaprobada",{
          ...infoData
         })
         .then(({data})=>{
          loadItems();

          if( data.status ){
            dispatch({
              type:ActionTypes.setModalInfo,
              data:{
                  title:"Orden de compra enviada",
                  message:data.msg,
                  type:DialogType.exitoso,
                  isVisible:true
              }
            });
          }else{

            dispatch({
              type:ActionTypes.setModalInfo,
              data:{
                  title:"Error",
                  message:data.msg,
                  type:DialogType.peligro,
                  isVisible:true
              }
            });

          }
          

         }).catch(error=>{

          if( error.response?.status === 504 ){

            dispatch({
              type:ActionTypes.setModalInfo,
              data:{
                  title:"Orden parcialmente generada",
                  message:"Su orden fue generada con exito pero el proceso no completo correctamente por favor verifique su orden en la pantalla ORDENES DE COMPRA",
                  type:DialogType.informativo,
                  isVisible:true
              }
            });

          }else{

            dispatch({
              type:ActionTypes.setModalInfo,
              data:{
                  title:"Error",
                  message:"Error de comunicacion verifique su conexion a internet",
                  type:DialogType.peligro,
                  isVisible:true
              }
            });

          }

          

         })
         .finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
         });

      }


      const onAprobeConfirmacionOrdenCompra = (infoData) => {
        console.log({infoData});
        setDialogInternalConfig({
          isOpened:true,
          title:"Confirmar envio de orden de compra",
          content:"¿ Esta seguro de confirmar la compra?, Recuerde que al enviar este carrito ya no se va a poder editar o reversar, es importante haberlo revisando antes de enviarlo",
          actions:[
            {
              buttomProps:{
                variant:"contained",
                color:"secondary",
                size:"small",
                onClick:()=>setDialogInternalConfig({})
              },
              title:"NO"
            },
            {
              buttomProps:{
                variant:"contained",
                color:"primary",
                size:"small",
                onClick:()=>{
                  setDialogInternalConfig({})
                  confirmarOrdenCompra(infoData);

                }
                
              },
              title:"SI"
            }
          ]
        });
      }


      

    return (<>

      <CustomDialog
        {...dialogInternalConfig}
      />
      
      {
       isVisibleModalDetalle && 
       <ModalComprarCotizaciones 
       opened={isVisibleModalDetalle}
       onCloseModal={onHideDetailProduct}
       cotizacionInfo={productoSeleccionado}
       />
      }
   
    <Grid container spacing={2} >
        <Grid item sm={12} xs={12} md={4} >

        <FilterForm
            buttomDist={
              {
                sx:3,
                md:3
              }
            }
            nameFilter={"Buscar compras por"}
            inputsFilter={InputFilters}
            schemaValidator={schemaFilter}
            initialValuesFilter={
            {  producto:InitialFilterSearch?.producto,
              proveedor:InitialFilterSearch?.fecha,
              
             
             }
            }
            onApplyFilter={setFilterAply}
          />

        </Grid>
      
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>
                <TableCell>

                </TableCell>
                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( (prod,prod_index)=>
                  [
                    <TableRow key={prod.key_item}  >
                       <TableCell>
                        <IconButton onClick={e=>onOpenedDetal(prod_index)} >
                          {prod.openedDetail? <VisibilityOffRounded />: <VisibilityRounded />}
                         
                        </IconButton>
                       </TableCell>
                    {
                      columnsTable.map(Col=>
                        <TableCell key={Col.key}  >
                          {<Col.bodyRender key={prod.key} value={prod[Col.keyValue]} info={prod} />}
                       </TableCell>)
                    }

                  </TableRow>,
                  <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={columnsTable.length + 1} >

                      <Collapse in={prod.openedDetail} unmountOnExit >
                        <SubtableItemsCesta onResetearCesta={ResetearItemCesta} items={prod.itemList} />
                      </Collapse>

                    </TableCell>
                  </TableRow>
                  ]
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}